import { CategoryResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import NextLink from "components/Reusable/Bit/NextLink"
import Image from "next/image"
import styled from "styled-components"
import { FixedItem } from "./GiftcardTypeStrip"

const StyledGiftcardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  max-width: 88px;
`

const StyledGiftcardBox = styled.div`
  border-radius: 16px;
  border: 1px solid #e5e5e5;
  background: var(--White, #fff);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;

  &:hover {
    border: 1px solid var(--Green, #264f36);
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 88px;
    height: 88px;
  }
`

const StyledGiftcardImage = styled(Image)``

const StyledGiftcardTypeTitle = styled.p`
  color: var(--Black, var(--Primary-Black, #000));
  text-align: center;
  font-family: Speedee, NarkisBlock;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  width: 80%;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 20px;
    letter-spacing: 0.3px;
  }
`

type IconStripProps = {
  data: CategoryResponse | FixedItem
  isNotCategory?: boolean
}

const GiftcardType = ({ data, isNotCategory }: IconStripProps) => {
  const isDesktop = useIsDesktop()

  const imgSize = isDesktop ? 64 : 48

  const url = isNotCategory ? `/${data?.slug}` : `/category/${data?.slug}`

  return (
    <NextLink href={url}>
      <StyledGiftcardContainer>
        <StyledGiftcardBox>
          <StyledGiftcardImage
            src={data?.icon?.imageUrl || "/icon-example.png"}
            alt={""}
            width={imgSize}
            height={imgSize}
          />
        </StyledGiftcardBox>
        <StyledGiftcardTypeTitle>{data?.name}</StyledGiftcardTypeTitle>
      </StyledGiftcardContainer>
    </NextLink>
  )
}

export default GiftcardType
